import * as actionTypes from './actionTypes';

export const fetchAllUsers = () => ({
  type: actionTypes.FETCH_ALL,
});
export const fetchAllUsersSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  ids,
});

export const fetchAllSpaceMembers = (spaceId) => ({
  type: actionTypes.FETCH_ALL_SPACE_MEMBERS,
  spaceId,
});
export const fetchAllSpaceMembersSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_SPACE_MEMBERS_SUCCESS,
  ids,
});

export const fetchUser = (id) => ({
  type: actionTypes.FETCH,
  id,
});
export const fetchUserSuccess = (id) => ({
  type: actionTypes.FETCH_SUCCESS,
  id,
});

export const fetchAllAuthors = () => ({
  type: actionTypes.FETCH_ALL_AUTHORS,
});
export const fetchAllAuthorsSuccess = (ids) => ({
  type: actionTypes.FETCH_ALL_AUTHORS_SUCCESS,
  ids,
});

export const createUser = (user) => ({
  type: actionTypes.CREATE,
  user,
});
export const createUserSuccess = (user) => ({
  type: actionTypes.CREATE_SUCCESS,
  user,
});

export const deleteUser = (user) => ({
  type: actionTypes.DELETE,
  user,
});
export const deleteUserSuccess = (id) => ({
  type: actionTypes.DELETE_SUCCESS,
  id,
});

export const updateUser = (user) => ({
  type: actionTypes.UPDATE,
  user,
});
export const updateUserSuccess = (id) => ({
  type: actionTypes.UPDATE_SUCCESS,
  id,
});

export const setEditingUserId = (id) => ({
  type: actionTypes.SET_EDITING_USER_ID,
  id,
});
